export default __webpack_public_path__ + "static/media/icon-circle.97dac8c9.svg";